<template>
  <div class="network-exception">
    <div class="error-info">
      <span class="warn-icon">!</span><span>{{ connectTxt }}</span>
    </div>
    <van-button v-if="!wsLoading" class="reconnect-btn" size="mini" @click="emit('reconnect')" :loading="wsLoading">try
      again</van-button>
    <van-loading v-else size="20" type="spinner" />
  </div>
</template>
<script setup>
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useMsgStore } from '@/states/msg'
const msgStore = useMsgStore();
const { wsLoading } = storeToRefs(msgStore);
const connectTxt = computed(() => wsLoading.value ? 'Network connection' : 'Network disconnection');

const emit = defineEmits(['reconnect']);
const props = defineProps({
  type: {
    type: String,
    defaut: ''
  },
  isRoomList: {
    type: Boolean,
    default: false,
  }
})

</script>
<style lang="scss" scoped>
.network-exception {
  color: rgb(255, 73, 38);
  background-color: rgb(255, 234, 229);
  padding: 8px 4px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 4px;
  border-radius: 3px;
  font-size: 12px;

  .warn-icon {
    display: inline-block;
    width: 16px;
    height: 16px;
    line-height: 16px;
    text-align: center;
    background-color: rgb(255, 73, 38);
    color: #fff;
    border-radius: 50%;
    margin: 0 6px;
  }

  .reconnect-btn {
    background-color: #fff;
    border: 1px solid #ddd;
    border-radius: 3px;
    padding-left: 10px;
    padding-right: 10px;
  }
}
</style>